<template>
  <div class="report-wrapper">
    <article v-if="isMobileView" class="data-card box box--default">
      <header class="data-card__header">
        <button v-if="report.agent" type="button" class="data-card__identity" @click.stop>
          <span class="data-card__avatar">
            <span class="icon icon__policy--default"></span>
          </span>
          <span class="data-card__name">
            {{ report.agent }}
          </span>
        </button>

        <template v-if="!report.policy_service">
          <div v-if="canViewReport && report.payout_id != null && report.type_id == 9"
            class="data-card__action icon icon__print" @click="openReport()"></div>
          <div v-else-if="canDeleteReport && !report.payout_id && report.type?.is_manual"
            class="data-card__action icon icon__delete" @click="deleteReport(report.uuid)"></div>
          <div v-if="canViewReport && report.payout_id != null && report.type_id == 9"
            class="data-card__action icon icon__excel" @click="openReportExcel()"></div>
        </template>
        <router-link v-else class="data-card__action icon icon__right-arrow" :to="{
          name: 'AccountDetails',
          params: {
            entity: 'customer',
            id: report.customer.id,
          },
        }"></router-link>
      </header>

      <dl v-if="!report.policy_service" class="data-card__details">
        <div v-if="report.date" class="data-card__detail">
          <dt>{{ $t ? $t('userReport.date') : 'Date' }}</dt>
          <dd>{{ formatDisplayDate(report.date) }}</dd>
        </div>
        <div v-if="report.type?.name || report.user" class="data-card__detail">
          <dt>{{ $t ? $t('userReport.type') : 'Type' }}</dt>
          <dd>
            <template v-if="report.type?.name">{{ report.type.name }}</template>
            <template v-if="report.user">- {{ report.user }}</template>
          </dd>
        </div>
        <div v-if="report.description" class="data-card__detail data-card__detail-full">
          <dt>{{ $t ? $t('userReport.description') : 'Description' }}</dt>
          <dd>{{ report.description }}</dd>
        </div>
        <div class="data-card__detail">
          <dt>{{ $t ? $t('userReport.balance') : 'Balance' }}</dt>
          <dd>{{ isOpened === 0 ? storno : balance }} CHF</dd>
        </div>
      </dl>

      <dl v-else class="data-card__details">
        <div v-if="customerName" class="data-card__detail data-card__detail-full">
          <dt>{{ $t ? $t('userReport.customer') : 'Customer' }}</dt>
          <dd>{{ customerName }}</dd>
        </div>
        <div v-if="report.company" class="data-card__detail">
          <dt>{{ $t ? $t('userReport.company') : 'Company' }}</dt>
          <dd>{{ report.company }}</dd>
        </div>
        <div v-if="insuranceType" class="data-card__detail">
          <dt>{{ $t ? $t('userReport.insType') : 'Insurance type' }}</dt>
          <dd>{{ insuranceType }}</dd>
        </div>
        <div v-if="report.policy_number" class="data-card__detail">
          <dt>{{ $t ? $t('userReport.policyNr') : 'Policy nr' }}</dt>
          <dd>{{ report.policy_number }}</dd>
        </div>
        <div v-if="report.agent" class="data-card__detail">
          <dt>{{ $t ? $t('userReport.agent') : 'Agent' }}</dt>
          <dd>{{ report.agent }}</dd>
        </div>
        <div v-if="report.type?.name" class="data-card__detail">
          <dt>{{ $t ? $t('userReport.type') : 'Type' }}</dt>
          <dd>
            <template v-if="report.type?.name">{{ report.type.name }}</template>
            <template v-if="report.user">- {{ report.user }}</template>
          </dd>
        </div>
        <div class="data-card__detail">
          <dt>{{ $t ? $t('userReport.balance') : 'Balance' }}</dt>
          <dd>{{ isOpened === 0 ? storno : balance }} CHF</dd>
        </div>
      </dl>
    </article>

    <template v-else>
      <template v-if="!report.policy_service">
        <div v-if="report" class="report">
          <div class="report__data report__data--small">
            {{ formatDisplayDate(report.date) }}
          </div>
          <div class="report__data report__data--medium">{{ report.agent }}</div>
          <div class="report__data report__data--medium"
          :title="`${report.type?.name || ''}${report.user ? ' - ' + report.user : ''}`.trim()">
            <template v-if="report.type">
              {{ report.type.name }}
            </template>
            <template v-if="report.user">
              - {{ report.user }}
            </template>
          </div>
          <div class="report__data report__data--large">
            {{ report.description }}
          </div>
          <div class="report__data report__data--small">
            {{ isOpened === 0 ? storno : balance }}
            CHF
          </div>

          <div class="report__data report__data--small multiple-actions">
            <template v-if="!report.policy_service">
              <div v-if="canViewReport && report.payout_id != null && report.type_id == 9" class="icon icon__print"
                @click="openReport()">
              </div>
              <div v-else-if="canDeleteReport && !report.payout_id && report.type?.is_manual" class="icon icon__delete"
                @click="deleteReport(report.uuid)">
              </div>
              <div v-if="canViewReport && report.payout_id != null && report.type_id == 9" class="icon icon__excel"
                @click="openReportExcel()"></div>
            </template>
            <router-link v-else class="icon icon__right-arrow" :to="{
              name: 'AccountDetails',
              params: {
                entity: 'customer',
                id: report.customer.id,
              },
            }"></router-link>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="report" v-if="report">
          <div class="report__data report__data--medium">
            {{ formatDisplayDate(report.date) }}
          </div>
          <div class="report__data report__data--large">
            {{ customerName }}
          </div>
          <div class="report__data report__data--large">
            {{ report.company }}
          </div>
          <div class="report__data report__data--medium">
            {{ insuranceType }}
          </div>
          <div class="report__data report__data--medium">
            {{ report.policy_number }}
          </div>
          <div class="report__data report__data--medium">
            {{ report.agent }}
          </div>
          <div v-if="report" class="report__data report__data--medium">
            <template v-if="report.type">
              {{ report.type.name }}
            </template>
            <template v-if="report.user">
              - {{ report.user }}
            </template>
          </div>
          <div class="report__data report__data--medium">
            <p style="text-align: center">{{ isOpened === 0 ? storno : balance }}
              CHF</p>
          </div>

          <div class="report__data report__data--small multiple-actions">
            <router-link class="icon icon__right-arrow" :to="{
              name: 'AccountDetails',
              params: {
                entity: 'customer',
                id: report.customer.id,
              },
            }"></router-link>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, ref } from "vue";
import { useStore } from "vuex";
import api from "@/api";
import { formatDisplayDate } from "@/helpers/dateFormatters";
import statics from "@/statics";

defineOptions({
  name: "Report"
});

const props = defineProps({
  report: {
    required: true,
    type: Object,
  },
  teamId: {
    required: true,
    type: Number,
  },
});

const store = useStore();
const isMobileView = ref(false);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canViewReport = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission("report_show", props.teamId);
});
const canDeleteReport = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission("report_delete", props.teamId);
});

const updateMobileView = () => {
  isMobileView.value = window.innerWidth <= 900;
};

onMounted(() => {
  updateMobileView();
  window.addEventListener("resize", updateMobileView);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateMobileView);
});

// Computed Properties
const customerName = computed(() => {
  if (props.report.customer) {
    if (props.report.customer.company_name) {
      return props.report.customer.company_name;
    }
    return `${props.report.customer.first_name} ${props.report.customer.last_name}`;
  }
  return statics.empty;
});

const insuranceType = computed(() => {
  if (props.report.policy_service) {
    return props.report.policy_service.length
      ? props.report.policy_service[0].branch_category_service.code
      : statics.empty;
  }
  return statics.empty;
});

const storno = computed(() => {
  if (props.report.policy_service) {
    return props.report.policy_service.length
      ? props.report.policy_service[0].policy_service_payment.agent
      : statics.empty;
  } else {
    return props.report.debit || statics.empty;
  }
});

const isOpened = computed(() => {
  if (props.report.policy_service) {
    for (let service of props.report.policy_service) {
      if (service.policy_service_payment) {
        for (let payment of service.policy_service_payment) {
          if (!payment.paid) return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }
  return false;
});

const balance = computed(() => props.report.balance);

// Methods
const deleteReport = (id) => {
  if (!canDeleteReport.value) return;
  store.commit("setDeleteModal", {
    display: true,
    message: '',
    action: () => deleteManualReport(id),
    id: id,
  });
};

const deleteManualReport = async (id) => {
  if (!canDeleteReport.value) return;
  try {
    await api({ requiresAuth: true }).delete(`/v1/transactions/${id}`);
    await store.dispatch("getReports", props.teamId);
  } catch (err) {
    console.error(err);
  }
};

const openReport = async () => {
  if (!canViewReport.value) return;
  try {
    const response = await api({ requiresAuth: true }).get(
      `/v1/user-payouts/${props.report.payout_id}/pdf`,
      { responseType: "blob" }
    );

    if (!response.data || response.data.size === 0) {
      throw new Error("Empty PDF response received");
    }

    const contentType = response.headers['content-type'] || 'application/pdf';
    const blob = new Blob([response.data], { type: contentType });
    const fileURL = window.URL.createObjectURL(blob);

    if (contentType.includes("pdf") || contentType.includes("image/")) {
      const { width, height } = screen;
      window.open(
        fileURL,
        "_blank",
        `location=yes,width=${width},height=${height},scrollbars=yes,status=yes`
      );
    } else {
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "agent_payout.pdf");
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
    }

    window.URL.revokeObjectURL(fileURL);
  } catch (err) {
    console.error("PDF download error:", err);
    const errorMessage = err.response?.data instanceof Blob
      ? "Server error while generating PDF"
      : (err.response?.data?.message || "Error downloading PDF. Please try again.");

    store.commit("setToast", {
      display: true,
      type: "error",
      message: errorMessage
    });
  }
};

const openReportExcel = async () => {
  if (!canViewReport.value) return;
  try {
    const response = await api({ requiresAuth: true }).get(
      `/v1/user-payouts/${props.report.payout_id}/excel`,
      { responseType: "blob" }
    );

    if (!response.data || response.data.size === 0) {
      throw new Error("Empty Excel response received");
    }

    const contentType = response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const blob = new Blob([response.data], { type: contentType });
    const fileURL = window.URL.createObjectURL(blob);

    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", "agent_payout.xlsx");
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);

    window.URL.revokeObjectURL(fileURL);
  } catch (err) {
    console.error("Excel download error:", err);
    const errorMessage = err.response?.data instanceof Blob
      ? "Server error while generating Excel"
      : (err.response?.data?.message || "Error downloading Excel. Please try again.");

    store.commit("setToast", {
      display: true,
      type: "error",
      message: errorMessage
    });
  }
};
</script>

<style scoped lang="scss">
.report {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  border-radius: var(--radius-1);
  background: var(--bg-1);
  box-shadow: 0px 0px 15px var(--shadow-4);
  position: relative;
  z-index: 1;

  &__data {
    border-right: 1px solid var(--border-12);
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 15px 10px;
    color: var(--text-9);

    &--small,
    &--last {
      flex: 1;
    }

    &--medium {
      flex: 2;
    }

    &--large {
      flex: 3;
    }

    &--last {
      max-width: 45px;
      border-right: 0;
    }

    &:last-child {
      border-right: 0;
    }
  }
}

.report-wrapper {
  width: 100%;
}

.multiple-actions {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

@media (max-width: 900px) {
  .report__details-reports {
    .row {
      margin-bottom: 20px;
    }
  }

  .report-wrapper {
    .data-card {
      display: block;
      padding: 14px;
      background: var(--bg-1);
      color: var(--text-9);

      &__header,
      &__identity,
      &__details {
        display: flex;
      }

      &__header {
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid var(--border-7);
      }

      &__identity {
        min-width: 0;
        align-items: center;
        gap: 10px;
        padding: 0;
        background: transparent;
        color: inherit;
        text-align: left;
      }

      &__avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border: 2px solid var(--border-2);
        border-radius: 50%;
        background-color: var(--bg-3);

        .icon {
          width: 22px;
          height: 22px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 22px;
        }
      }

      &__name,
      &__name span {
        min-width: 0;
        font-family: var(--muli-text-bold);
        font-size: var(--small);
        overflow-wrap: anywhere;
      }

      &__action {
        flex: 0 0 40px;
        width: 40px;
        height: 40px;
        padding: 0;
        border-radius: var(--radius-1);
        background-color: var(--bg-3);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 22px;
      }

      &__details {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        margin: 12px 0 0;
      }

      &__detail {
        min-width: 0;

        dt {
          margin-bottom: 4px;
          color: var(--text-2);
          font-family: var(--muli-text-semi-bold);
          font-size: var(--x-smaller);
          text-transform: uppercase;
        }

        dd {
          margin: 0;
          font-size: var(--x-small);
          overflow-wrap: anywhere;
        }

        &-full {
          grid-column: 1 / -1;
        }
      }
    }
  }
}

.report__data {
  white-space: pre-wrap !important;
  overflow-wrap: break-word !important;
}
</style>
